import React from 'react'
import { Container } from './styles'
import { LabelRow, ColumnEllipse } from '~/components/shared'

export interface RowInfoPartProps {
  isFilled: boolean
  period: string | number
  quantity?: number
  children: React.ReactNode
}

export const RowInfoPart = ({ isFilled, period, quantity, children }: RowInfoPartProps): JSX.Element => {
  return (
    <Container>
      <LabelRow period={period} quantity={quantity} isFilled={isFilled} />
      <ColumnEllipse isFilled={isFilled}>{children}</ColumnEllipse>
    </Container>
  )
}
